<template>
    <xx-poi-select
        :size="size"
        @input="input"
        :selectItems="value"
        v-bind="$attrs"
        v-on="$listeners"
    ></xx-poi-select>
</template>

<script>
import PoiSelect from '../../PoiSelect';

export default {
    name: 'XxPoi',
    props: {
        value: {
            required: true
        },
        size: {
            type: String,
            default: 'small'
        }
    },
    components: {
        PoiSelect
    },
    watch: {},
    methods: {
        input(val) {
            this.$emit('input', val);
        }
    }
};
</script>
